import { httpClient } from './HttpClient';

export const EmailNotificationsApi = {
  deleteSelectedRows: (payload: number[]) => {
    const url = `/api/odata/v4/emailnotifications/DeleteSelected`;
    const data = { keys: payload };
    return httpClient.post(url, data);
  },
};
